import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    // 모든 spaceCode
    async getSpaceCodeList ({ state }, spaceid) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-waiting-call',
          func: 'get-waiting-call-spaceCode',
          id: store.state.authentication.requestId,
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex.response
      }
    },
    async getWaitingcallData () {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'waitingcall/waitingcall.json'
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setWaitingcallData ({ state }, data) {
      try {
        await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'waitingcall/waitingcall.json',
          data: JSON.stringify(data)
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    }
  },
  getters: {
    getWaitingcallResultData: () => (code) => {
      let result = true
      switch (code) {
        case 201:
          result = 'duplicate' // 중복등록(중복인증X)
          break
        case 210:
          result = 'group' // 그룹예약이 등록시도 할 경우
          break
        case 211:
          result = 'space' // space 정보가 없는 경우
          break
        case 220:
          result = 'fail_send' // 메시지 전송 실패
          break
        case 300:
          result = 'fail_auth' // 예약 정보가 없거나 인증 실패
          break
        case 310:
          result = 'fail_status_change' // 예약 상태 변경이 안되는 경우
          break
        case 401:
          result = 'inactivate' // 비활성화 또는 서비스 하지 않는 사이트
          break
        case 403:
          result = 'invalid_request' // 유효하지 않은 요청 데이터
          break
        case 405:
          result = 'invalid_site' // 사이트 정보가 없음
          break
        case 406:
          result = 'not_found_data' // 데이터가 없음
          break
        case 500:
          result = 'system_error' // 내부 오류
          break
      }
      return result
    }
  }
}
